import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ResultadoColeta } from '../../comum/modelos/resultado-coleta';
import { ResultadoCriterioColeta } from '../../comum/modelos/resultado-criterio-coleta';

@Component({
    selector: 'app-modal-lista-coletas',
    templateUrl: './modal-lista-coletas.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-lista-coletas.component.css']
})
export class ModalListaColetasComponent implements OnInit {

    @Input() resultadoColeta: ResultadoColeta;
    @Input() resultadoCriterioColeta: ResultadoCriterioColeta;

    constructor(private modalService: NgbModal) {
    }

    cadastrar(content: any) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalListaColetas',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/modal-lista-coletas/modal-lista-coletas.component.ts